import moment from 'moment-timezone';

import {
  getIssuesByClientByCreatedAt,
  getIssuesByElderByCreatedAt,
} from 'graphql/queries';
import {
  getOrdersByClientByDate,
  getOrdersByElderByDate,
} from './queries';
import { asyncListAll, asyncListAllAndUpdateLastItem } from 'utilities/graph';
import { TIME_ZONE } from '@silvergatedelivery/constants';

export function getStartEndByPeriodName(inPeriod) {
  const [period, startBaseline, endBaseline] = inPeriod.split('/');
  const startBaseNumber = parseInt(startBaseline || '0');
  const endBaseNumber = parseInt(endBaseline || '0');
  const start = moment().add(startBaseNumber, `${period}s`).tz(TIME_ZONE).startOf(period);
  const end = moment().add(endBaseNumber, `${period}s`).tz(TIME_ZONE).endOf(period);
  return {
    start: start.toISOString(),
    end: end.toISOString(),
    prevStart: moment().tz(TIME_ZONE).add(-1 + startBaseNumber, `${period}s`).startOf(period).toISOString(),
    prevEnd: moment().tz(TIME_ZONE).add(-1 + endBaseNumber, `${period}s`).endOf(period).toISOString(),
    startFormat: start.format('YYYY-MM-DD'),
    endFormat: end.format('YYYY-MM-DD'),
  };
}

export function getDatesBetween(startISO, endISO, format='YYYY-MM-DD') {
  const startDate = moment(startISO);
  const endDate = moment(endISO);
  const dates = [];

  while (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
    dates.push(startDate.format(format));
    startDate.add(1, 'days');
  }

  return dates;
}

export const getOrders = async (clientIds, start, end, onUpdateLastItem, organizationId, organizationData) => {
  let results = [];
  await Promise.all(clientIds.map(async (clientId) => {
    const clientParams = organizationData?.clients?.items.find((data) => data.clientId === clientId);

    // 脆家中心模式，只顯示組織的送餐對象
    const ownedElderOnly = clientParams?.elderSetting &&
      !clientParams?.visitorMode &&
      !clientParams?.clientMode;

    if (ownedElderOnly) {
      const elderIds = await asyncListAll(`
        query GetEldersByClientByOrganization(
          $clientId: ID
          $organizationId: ModelIDKeyConditionInput
          $sortDirection: ModelSortDirection
          $filter: ModelElderFilterInput
          $limit: Int
          $nextToken: String
        ) {
          getEldersByClientByOrganization(
            clientId: $clientId
            organizationId: $organizationId
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
            }
            nextToken
          }
        }
      `, {
        clientId,
        organizationId: { eq: organizationId },
      });
      const data = (await Promise.all(elderIds.map(async (elder) => {
        return await asyncListAllAndUpdateLastItem(getOrdersByElderByDate, {
          elderId: elder.id,
          date: {
            between: [start, end],
          },
        });
      }))).flat();
      results = [...results, ...data];
    } else {
      const data = await asyncListAllAndUpdateLastItem(getOrdersByClientByDate, {
        clientId,
        date: {
          between: [start, end],
        },
        filter: {
          status: { ne: 'cancelled' },
        },
        limit: 1000,
      }, onUpdateLastItem);
      results = [...results, ...data];
    }
  }));

  return results;
};
export const getIssues = async (clientIds, start, end, organizationId, organizationData) => {
  let results = [];

  await Promise.all(clientIds.map(async (clientId) => {
    const clientParams = organizationData?.clients?.items.find((data) => data.clientId === clientId);

    // 脆家中心模式，只顯示組織的送餐對象
    const ownedElderOnly = clientParams?.elderSetting &&
      !clientParams?.visitorMode &&
      !clientParams?.clientMode;

    if (ownedElderOnly) {
      const elderIds = await asyncListAll(`
        query GetEldersByClientByOrganization(
          $clientId: ID
          $organizationId: ModelIDKeyConditionInput
          $sortDirection: ModelSortDirection
          $filter: ModelElderFilterInput
          $limit: Int
          $nextToken: String
        ) {
          getEldersByClientByOrganization(
            clientId: $clientId
            organizationId: $organizationId
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
            }
            nextToken
          }
        }
      `, {
        clientId,
        organizationId: { eq: organizationId },
      });
      const data = (await Promise.all(elderIds.map(async (elder) => {
        return await asyncListAllAndUpdateLastItem(getIssuesByElderByCreatedAt, {
          elderId: elder.id,
          date: {
            between: [start, end],
          },
        });
      }))).flat();
      results = [...results, ...data];
    } else {
      const data = await asyncListAll(getIssuesByClientByCreatedAt, {
        clientId,
        createdAt: {
          between: [start, end],
        },
      });
      results = [...results, ...data];
    }
  }));

  return results;
};
